import Label from "@ingka/label";
import { Select, Option } from "@ingka/select";
import FormField from "@ingka/form-field";
import LabelWithToolTip from "@/components/LabelWithTooltip/LabelWithToolTip";
import { useMetadataFields } from "@/components/MetadataFields/hooks";

type Props = {
  options: Record<string, string>;
  disabled: boolean;
};

const FiscalYear = ({ options, disabled }: Props) => {
  const {
    getValidationError,
    activeAsset,
    updateMetadata,
    isMetadataUpdating,
  } = useMetadataFields();
  const error = getValidationError("fiscalYear", activeAsset.id!);
  const isUpdating = isMetadataUpdating(activeAsset.id!, "fiscalYear");
  return (
    <>
      <Label
        htmlFor="fiscalYear"
        label={
          <LabelWithToolTip
            labelText="FY"
            toolTipText="During which financial year are these assets to be used? Please note that IKEAs financial years is the period between September 1st and August 31st.Example: FY26 starts September 1st 2025."
          />
        }
      />
      <FormField
        valid="error"
        validation={{
          msg: error?.message,
          type: "error",
        }}
        shouldValidate={Boolean(error)}
      >
        <Select
          id="fiscalYear"
          value={activeAsset.fiscalYear || ""}
          disabled={disabled || isUpdating}
          onChange={(e) => {
            updateMetadata({
              fiscalYear: e.target.value,
            });
          }}
        >
          {Object.entries(options)
            .sort(([a], [b]) => (a >= b ? -1 : 1))
            .map(([name, label]) => (
              <Option key={name} name={label} value={name} />
            ))}
        </Select>
      </FormField>
    </>
  );
};

export default FiscalYear;
